// extracted by mini-css-extract-plugin
export default {"NavbarContainer":"styles_NavbarContainer__OrRDq","NavbarOnTop":"styles_NavbarOnTop__-qA2r","navItemsWrapper":"styles_navItemsWrapper__gJ3fR"};